define('presentation/settings/accountProfile/viewModels/accountProfileViewModel',[
        'businessServices/authentication/sessionAccountInfo',
        'businessServices/converters/textConverter',
        'businessServices/country/countryRegions',
        'businessServices/country/timeZones',
        'businessServices/state/modelStateObserver',
        'common/collections/collectionSorter',
        'common/collections/enumerationKeyValueConverter',
        'common/converters/phoneNumberFormatter',
        'common/promises/promiseFactory',
        'common/storage/commonState',
        'constants/accountStatusEnumerations',
        'constants/billingMethodConstants',
        'constants/companySizeEnumerations',
        'constants/countryEnumerations',
        'constants/marketingIndustryEnumerations',
        'settings/navigationConfiguration',
        'plugins/router',
        'presentation/settings/accountProfile/facades/accountProfileFacade',
        'presentation/settings/accountProfile/presentationObjects/accountProfilePresentationObject',
        'presentation/settings/accountProfile/validators/accountProfileValidator',
        'presentation/settings/closeAccount/viewModels/closeAccountPortInProgressActionModalViewModel',
        'presentation/common/actionModal/viewModels/actionModalViewModel',
        'presentation/common/subscriberSelection/viewModels/subscriberSelectionViewModel',
], function() {
        return function() {
            const self = this;

            const CountryRegionsConstructor = require('businessServices/country/countryRegions');
            const _countryRegions = new CountryRegionsConstructor();

            const PhoneNumberFormatterConstructor = require('common/converters/phoneNumberFormatter');
            const _phoneNumberFormatter = new PhoneNumberFormatterConstructor();

            const PromiseFactoryConstructor = require('common/promises/promiseFactory');
            const _promiseFactory = new PromiseFactoryConstructor();

            const SorterConstructor = require('common/collections/collectionSorter');
            const _sorter = new SorterConstructor();

            const TextConverterConstructor = require('businessServices/converters/textConverter');
            const _textConverter = new TextConverterConstructor();

            const TimeZoneProviderConstructor = require('businessServices/country/timeZones');
            const _timeZoneProvider = new TimeZoneProviderConstructor();

            const AccountProfilePresentationObjectConstructor = require('presentation/settings/accountProfile/presentationObjects/accountProfilePresentationObject');
            const ActionModalConstructor = require('presentation/common/actionModal/viewModels/actionModalViewModel');
            const CloseAccountPortInProgressActionModalViewModel = require('presentation/settings/closeAccount/viewModels/closeAccountPortInProgressActionModalViewModel');
            const ModelStateObserverConstructor = require('businessServices/state/modelStateObserver');

            const _accountStatusEnumerations = require('constants/accountStatusEnumerations');
            const _billingMethodConstants = require('constants/billingMethodConstants');
            const _commonState = require('common/storage/commonState');
            const _companySizeEnumerations = require('constants/companySizeEnumerations');
            const _countryEnumerations = require('constants/countryEnumerations');
            const _i18n = require('i18next');
            const _industryEnumerations = require('constants/marketingIndustryEnumerations');
            const _keyValueConverter = require('common/collections/enumerationKeyValueConverter');
            const _navigationConfig = require('settings/navigationConfiguration');
            const _selectControlAvatarType = require('constants/selectControlAvatarType');
            const _sessionAccountInfo = require('businessServices/authentication/sessionAccountInfo');

            let _facade = null;
            let _router = null;
            let _validator = null;

            let _disposables = [];

            const EMAIL_ADDRESS_TYPE = "emailAddress";
            const MAX_CC_EMAIL_ADDRESSES = 10;

            const _buildBillingCommunicationsForSave = () => {
                const billingCommunicationEmails = self.billingCommunicationEmailAddresses()
                    .filter((billingCommunicationEmailAddress) => {
                        return billingCommunicationEmailAddress.emailAddress() !== "";
                    })
                    .map((billingCommunicationEmailAddress) => {
                        return {
                            type: EMAIL_ADDRESS_TYPE,
                            userId: null,
                            userGroupId: null,
                            emailAddress: billingCommunicationEmailAddress.emailAddress()
                        };
                    });

                const billingCommunicationSubscribers = self.billingCommunicationSubscribers()
                    .map((billingCommunicationSubscriber) => {
                        const subscriber = ko.unwrap(billingCommunicationSubscriber);
                        if (subscriber.userId) {
                            return {
                                type: _commonState.types.user,
                                userId: subscriber.userId,
                                userGroupId: null,
                                emailAddress: ""
                            };
                        }
                        if (subscriber.userGroupId) {
                            return {
                                type: _commonState.types.userGroup,
                                userId: null,
                                userGroupId: _commonState.resolveGroupIdToGuid(subscriber.userGroupId),
                                emailAddress: ""
                            };
                        }
                    });

                return billingCommunicationEmails.concat(billingCommunicationSubscribers);
            };

            const _getSubscribersForSave = () => {
                self.subscriberSelectionViewModel.getSubscribers()
                    .done((result) => {
                        self.billingCommunicationSubscribers(result.subscribers);
                    });
            };

            const _onCountryChange = (countryCode) => {
                self.zipOrPostalCode("");
                self.zipOrPostalCode.isValid(null);
                self.stateOrProvince(null);
                self.stateOrProvince.isValid(null);
                self.statesProvinces(_countryRegions.findByAbbreviation(countryCode).statesProvinces);
            };

            const _removeEmptyCCsBeforeSave = () => {
                let emptyAddedCCs = self.billingCommunicationEmailAddresses().filter((cc) => {
                    return cc.emailAddress() === "";
                });
                self.billingCommunicationEmailAddresses.removeAll(emptyAddedCCs);
            };

            const _prepareBillingEmailAddressForDisplay = ({ type, emailAddress }) => ({
                type,
                emailAddress: ko.observable(emailAddress).extend({observeState: true}),
            });

            const _setInvalidItems = (items) => {
                let invalidFields = [];
                if (items) {
                    invalidFields.push(...items);
                }
                self.invalidItems(invalidFields);
            };

            const _saveAccountProfile = (accountProfile) => {
                return _promiseFactory.deferIndefinitely((promise) => {
                    _getSubscribersForSave();

                    accountProfile.howWillYouUseTresta = self.howWillYouUseTresta().trim();
                    accountProfile.billingCommunications = _buildBillingCommunicationsForSave();

                    _facade.saveAccountProfile(accountProfile)
                        .fail(promise.reject)
                        .done((result) => {
                            if (result) {
                                const billingSubscribers =  result.billingCommunications.filter((s) => s.type === _commonState.types.user || s.type === _commonState.types.userGroup);
                                self.billingCommunicationSubscribers(billingSubscribers);
                                const billingEmailAddresses = result.billingCommunications
                                    .filter(({ type }) => type === EMAIL_ADDRESS_TYPE)
                                    .map(_prepareBillingEmailAddressForDisplay);
                                self.billingCommunicationEmailAddresses(billingEmailAddresses);
                                self.modelStateObserver.saveData();
                                promise.resolve();
                            } else {
                                self.modelStateObserver.saveData();
                                promise.resolve();
                            }
                        });
                });
            };

            self.modelStateObserver = null;

            self.allUsersAndUserGroups = ko.observable();
            self.companySizes = [];
            self.countries = [];
            self.statesProvinces = ko.observableArray([]);
            self.industries = [];

            self.accountNumber = ko.observable("");
            self.accountStatus = ko.observable();
            self.billingMethod = ko.observable(_billingMethodConstants.CreditCard);
            self.billingMethodLabel = ko.pureComputed(() => {
                const billingMethod = self.billingMethod();
                const billingMethodKey = Object.keys(_billingMethodConstants)
                    .find((key) => _billingMethodConstants[key] === billingMethod) || 'CreditCard';
                return _i18n.t(`accountProfile:billingMethods.${_textConverter.camelCase(billingMethodKey)}`);
            });
            self.doesAccountHaveActiveNumberPortsInProgress = ko.observable(false);
            self.howWillYouUseTresta = ko.observable("").extend({observeState: true});

            self.accountHolderFirstName = ko.observable("").extend({observeState: true});
            self.accountHolderLastName = ko.observable("").extend({observeState: true});
            self.businessName = ko.observable("").extend({observeState: true});
            self.addressLineOne = ko.observable('').extend({observeState: true});
            self.addressLineTwo = ko.observable('').extend({observeState: true});
            self.city = ko.observable('').extend({observeState: true});
            self.stateOrProvince = ko.observable().extend({observeState: true});
            self.country = ko.observable().extend({observeState: true});
            self.zipOrPostalCode = ko.observable('').extend({observeState: true});

            self.pointOfContactFirstName = ko.observable('').extend({observeState: true});
            self.pointOfContactLastName = ko.observable('').extend({observeState: true});
            self.phoneNumber = ko.observable('').extend({observeState: true});
            self.phoneNumberCountryAbbreviation = ko.observable(_countryEnumerations.usa).extend({observeState: true});

            self.inBusinessSince = ko.observable('').extend({observeState: true});
            self.numberOfEmployees = ko.observable().extend({observeState: true});
            self.industry = ko.observable().extend({observeState: true});
            self.timeZone = ko.observable('').extend({observeState: true});
            self.websiteUrl = ko.observable('').extend({observeState: true});

            self.billingCommunicationSubscribers = ko.observableArray([]).extend({observeState: true});
            self.billingCommunicationEmailAddresses = ko.observableArray([]).extend({observeState: true});
            self.maxCCEmailsMessage = _i18n.t('accountProfile:maxCCEmailsMessage');

            self.invalidItems = ko.observableArray([]);
            self.isAccountProfileSaved = ko.observable(true);
            self.shouldScrollToTop = ko.observable(false);
            self.showWarningMessage = ko.observable(false);

            self.isImpersonating = ko.pureComputed(() => _sessionAccountInfo.isImpersonating());

            const _availableTimezones = _timeZoneProvider.getSortedTimeZones();
            self.timeZones = _availableTimezones.map((timeZone) => {
                timeZone.id = timeZone.key;
                timeZone.text = timeZone.name;
                return timeZone;
            });

            self.isAccountClosed = ko.pureComputed(() => self.accountStatus() === _accountStatusEnumerations.status.closed);
            self.selectPlaceHolderMessage = ko.pureComputed(() => _i18n.t("accountProfile:select"));

            self.canAddAnotherBillingCommunicationEmailAddress = ko.pureComputed(() => self.billingCommunicationEmailAddresses().length < MAX_CC_EMAIL_ADDRESSES);
            self.addAnotherKey = ko.pureComputed(() => {
                return self.billingCommunicationEmailAddresses().length > 0 ? 'accountProfile:addAnother' : 'accountProfile:add';
            });

            self.stateOrProvinceLabelI18nKey = ko.pureComputed(() => {
                return (self.country() === _countryEnumerations.ca) ?
                    'accountProfile:labelProvince' :
                    'accountProfile:labelState';
            });

            self.zipOrPostalCodeMetaData = ko.pureComputed(() => {
                return (self.country() === _countryEnumerations.ca) ?
                    {i18nLabelKey: 'accountProfile:labelPostalCode', type: 'postalcode', maxLength: 6} :
                    {i18nLabelKey: 'accountProfile:labelZipCode', type: 'zipcode', maxLength: 5};
            });

            self.allUsersAndUserGroups = ko.pureComputed(() => {
                const userPresentationObjects = _commonState.users()
                    .filter(u => u.isActive())
                    .map((u) => {
                        return {
                            id: u.id,
                            avatar: u.avatar,
                            userId: u.id,
                            userGroupId: null,
                            displayName: u.name,
                            avatarType: _selectControlAvatarType.user,
                        };
                    } );
                _sorter.sort(userPresentationObjects, "displayName", true);

                const userGroupPresentationObjects = _commonState.userGroups()
                    .filter(g => g.isActive())
                    .map((g) => {
                        return {
                            id: g.id,
                            avatar: g.avatars,
                            userId: null,
                            userGroupId: g.id,
                            displayName: g.name,
                            avatarType: _selectControlAvatarType.userGroup,
                        };
                    });
                _sorter.sort(userGroupPresentationObjects, "displayName", true);

                return [...userPresentationObjects, ...userGroupPresentationObjects];
            });

            self.warningMessages = ko.pureComputed(() => {
                return [
                    {
                        message: _i18n.t('accountProfile:oopsInvalidItems'),
                        listItems: self.invalidItems()
                    },
                    {
                        message: _i18n.t('accountProfile:pleaseCorrectInvalidFields'),
                        listItems: []
                    }
                ];
            });

            self.closeAccountClicked = () => {
                if (self.doesAccountHaveActiveNumberPortsInProgress()) {
                    const actionModal = new ActionModalConstructor();
                    actionModal.clearModal();
                    actionModal.setContentViewModel(CloseAccountPortInProgressActionModalViewModel);
                    actionModal.setHeaderText({i18n: 'closeAccount:portInProgress'});
                    actionModal.setCancelButtonText({i18n: 'common:dismiss'});
                    actionModal.shouldDisplayCancelButton(true);
                    actionModal.shouldDisplayAgentBypassButton(false);
                    actionModal.shouldDisplaySubmitButton(false);
                    actionModal.shouldDisplayDefaultFooterMessage(true);
                    actionModal.showModal();
                } else {
                    _router.navigate(_navigationConfig.routesById.closeAccount.url);
                }
            };

            self.addBillingCommunicationEmailAddress = () => {
                const addBillingEmail = {
                    type: EMAIL_ADDRESS_TYPE,
                    emailAddress: ko.observable('').extend({observeState: true}),
                };
                self.billingCommunicationEmailAddresses.push(addBillingEmail);
            };

            self.deleteBillingCommunicationSubscriber = (billingCommunication) => {
                self.billingCommunicationSubscribers.remove(billingCommunication);
            };

            self.deleteBillingCommunicationEmailAddress = (billingCommunication) => {
                self.billingCommunicationEmailAddresses.remove(billingCommunication);
                _validator.validate();
            };

            self.filterAvailableOptions = (allOptions, selectedOptions) => {
                let selectedOptionsKeys = [];
                selectedOptions.forEach((selectedOption) => {
                    const selectedOptionKey = selectedOption().key() + selectedOption().type();
                    selectedOptionsKeys[selectedOptionKey] = true;
                });
                return allOptions.filter((aOption) => {
                    const allOptionKey = aOption.key() + aOption.type();
                    return !selectedOptionsKeys[allOptionKey];
                });
            };

            self.getAccountProfile = () => {
                const accountProfilePresentationObject = new AccountProfilePresentationObjectConstructor();
                accountProfilePresentationObject.accountHolderFirstName = self.accountHolderFirstName();
                accountProfilePresentationObject.accountHolderLastName = self.accountHolderLastName();
                accountProfilePresentationObject.businessName = self.businessName();
                accountProfilePresentationObject.country = self.country();
                accountProfilePresentationObject.addressLineOne = self.addressLineOne();
                accountProfilePresentationObject.addressLineTwo = self.addressLineTwo();
                accountProfilePresentationObject.city = self.city();
                accountProfilePresentationObject.stateProvince = self.stateOrProvince();
                accountProfilePresentationObject.postalCode = self.zipOrPostalCode();
                accountProfilePresentationObject.inBusinessSince = self.inBusinessSince();
                accountProfilePresentationObject.numberOfEmployees = self.numberOfEmployees();
                accountProfilePresentationObject.industry = self.industry();
                accountProfilePresentationObject.timeZone = self.timeZone();
                accountProfilePresentationObject.websiteUrl = self.websiteUrl();
                accountProfilePresentationObject.pointOfContactFirstName = self.pointOfContactFirstName();
                accountProfilePresentationObject.pointOfContactLastName = self.pointOfContactLastName();
                accountProfilePresentationObject.phoneNumber = self.phoneNumber();
                return accountProfilePresentationObject;
            };

            self.invalidItems = () => {
                let invalidFields = [];
                if (self.accountHolderFirstName.isInvalid()) {
                    invalidFields.push(_i18n.t('accountProfile:labelFirstName'));
                }
                if (self.accountHolderLastName.isInvalid()) {
                    invalidFields.push(_i18n.t('accountProfile:labelLastName'));
                }
                if (self.addressLineOne.isInvalid()) {
                    invalidFields.push(_i18n.t('accountProfile:labelAddressLineOne'));
                }
                if (self.city.isInvalid()) {
                    invalidFields.push(_i18n.t('accountProfile:labelCity'));
                }
                if (self.stateOrProvince.isInvalid()) {
                    invalidFields.push(_i18n.t(self.stateOrProvinceLabelI18nKey()));
                }
                if (self.zipOrPostalCode.isInvalid()) {
                    invalidFields.push(_i18n.t(self.zipOrPostalCodeMetaData().i18nLabelKey));
                }
                if (self.inBusinessSince.isInvalid()) {
                    invalidFields.push(_i18n.t('accountProfile:labelMonthYearFounded'));
                }
                if (self.numberOfEmployees.isInvalid()) {
                    invalidFields.push(_i18n.t('accountProfile:labelCompanySize'));
                }
                if (self.industry.isInvalid()) {
                    invalidFields.push(_i18n.t('accountProfile:labelIndustry'));
                }

                return invalidFields;
            };

            self.validate = () => {
                return _promiseFactory.defer((promise) => {
                    _setInvalidItems();
                    _validator.validate()
                        .fail(promise.resolve)
                        .done((isValid) => {
                            _setInvalidItems(self.invalidItems());
                            promise.resolve(isValid);
                        });
                });
            };

            self.save = () => {
                self.shouldScrollToTop(false);
                return _promiseFactory.deferIndefinitely((promise) => {
                    _removeEmptyCCsBeforeSave();
                    self.validate()
                        .fail(promise.reject)
                        .done((isValid) => {
                            if (isValid === false) {
                                self.shouldScrollToTop(true);
                                self.showWarningMessage(true);
                                promise.resolve(false);
                                return;
                            }

                            self.showWarningMessage(false);
                            self.invalidItems([]);

                            const accountProfile = self.getAccountProfile();

                            _saveAccountProfile(accountProfile)
                                .fail(promise.reject)
                                .done(() => {
                                    promise.resolve();
                                    location.reload();
                                });
                        });
                });
            };

            self.resetValidation = () => {
                self.showWarningMessage(false);
                self.invalidItems([]);
                _validator.resetValidation();
            };

            self.cancelForm = () => {
                if (self.accountHolderFirstName.isDirty) {
                    self.accountHolderFirstName.forceUpdate(true);
                }
                if (self.accountHolderLastName.isDirty) {
                    self.accountHolderLastName.forceUpdate(true);
                }
                if (self.addressLineOne.isDirty) {
                    self.addressLineOne.forceUpdate(true);
                }
                if (self.addressLineTwo.isDirty) {
                    self.addressLineTwo.forceUpdate(true);
                }
                if (self.city.isDirty) {
                    self.city.forceUpdate(true);
                }
                if (self.zipOrPostalCode.isDirty) {
                    self.zipOrPostalCode.forceUpdate(true);
                }
                if (self.inBusinessSince.isDirty) {
                    self.inBusinessSince.forceUpdate(true);
                }
                if (self.websiteUrl.isDirty) {
                    self.websiteUrl.forceUpdate(true);
                }
                if (self.pointOfContactFirstName.isDirty) {
                    self.pointOfContactFirstName.forceUpdate(true);
                }
                if (self.pointOfContactLastName.isDirty) {
                    self.pointOfContactLastName.forceUpdate(true);
                }
                if (self.phoneNumber.isDirty) {
                    self.phoneNumber.forceUpdate(true);
                }

                self.modelStateObserver.restoreData();
                self.resetValidation();
            };

            self.detached = () => {
                _disposables.forEach(d => d.dispose());
                _disposables = [];
            };

            self.activate = () => {
                const FacadeConstructor = require('presentation/settings/accountProfile/facades/accountProfileFacade');
                _facade = new FacadeConstructor();
                _facade.init(_promiseFactory);

                const SubscriberSelectionConstructor = require('presentation/common/subscriberSelection/viewModels/subscriberSelectionViewModel');
                self.subscriberSelectionViewModel = new SubscriberSelectionConstructor();
                self.subscriberSelectionViewModel.addAnotherMessage = _i18n.t('accountProfile:noMoreBillingSubscribers');
                self.subscriberSelectionViewModel.isAtLeastOneItemRequired = true;
                self.subscriberSelectionViewModel.lastItemRemoveTitle(_i18n.t('accountProfile:lastBillingSubscriber'));

                const ValidatorConstructor = require('presentation/settings/accountProfile/validators/accountProfileValidator');
                _validator = new ValidatorConstructor();

                _router = require('plugins/router');

                return _initialize();
            };

            const _initialize = () => {
                let initPromiseFactory = new PromiseFactoryConstructor();

                self.companySizes = _keyValueConverter.convertToKeyValues(_companySizeEnumerations);
                self.industries = _keyValueConverter.convertToKeyValues(_industryEnumerations).map((option) => {
                    const i18nKey = _textConverter.camelCase(option.key);
                    return { key: option.value, title: _i18n.t(`accountProfile:industries.${i18nKey}`), value: option.value };
                }).sort((a, b) => {
                    if (a.title < b.title) {
                        return -1;
                    } else if (a.title > b.title) {
                        return 1;
                    }
                    return 0;
                });

                self.countries = _countryRegions.countryList;
                self.statesProvinces = ko.observableArray(_countryRegions.findByAbbreviation(_countryEnumerations.usa).statesProvinces);
                self.country = ko.observable(_countryRegions.findByAbbreviation(_countryEnumerations.usa).countryAbbreviation).extend({observeState: true});

                initPromiseFactory.defer((hasPortsInProgressPromise) => {
                    _facade.hasNumberPortsInProgress()
                        .fail((error) => {
                            throw error;
                        })
                        .done((doesAccountHaveNumberPortsInProgress) => {
                            self.doesAccountHaveActiveNumberPortsInProgress(doesAccountHaveNumberPortsInProgress);
                            hasPortsInProgressPromise.resolve();
                        });
                });

                initPromiseFactory.defer((getAccountProfilePromise) => {
                    _facade.getAccountProfile()
                        .fail(getAccountProfilePromise.reject)
                        .done((accountProfile) => {
                            self.accountNumber(accountProfile.accountNumber);
                            self.accountStatus(accountProfile.accountStatus);
                            self.billingMethod(Number(accountProfile.billingMethod) || _billingMethodConstants.CreditCard);

                            self.accountHolderFirstName(accountProfile.accountHolderFirstName);
                            self.accountHolderLastName(accountProfile.accountHolderLastName);
                            self.businessName(accountProfile.businessName);

                            if (accountProfile.howWillYouUseTresta) {
                                self.howWillYouUseTresta(accountProfile.howWillYouUseTresta);
                            }

                            if (accountProfile.country) {
                                self.country(_countryRegions.findByAbbreviation(accountProfile.country.toLowerCase()).countryAbbreviation);
                                self.statesProvinces = ko.observableArray(_countryRegions.findByAbbreviation(accountProfile.country.toLowerCase()).statesProvinces);
                            }
                            self.addressLineOne(accountProfile.addressLineOne);
                            self.addressLineTwo(accountProfile.addressLineTwo);
                            self.city(accountProfile.city);
                            self.stateOrProvince(accountProfile.stateProvince);
                            self.zipOrPostalCode(accountProfile.postalCode);

                            self.inBusinessSince(accountProfile.inBusinessSince);
                            if (accountProfile.numberOfEmployees) {
                                self.numberOfEmployees(accountProfile.numberOfEmployees);
                            }
                            if (accountProfile.industry) {
                                self.industry(accountProfile.industry);
                            }
                            self.timeZone(accountProfile.timeZone);
                            self.websiteUrl(accountProfile.websiteUrl);

                            self.pointOfContactFirstName(accountProfile.pointOfContactFirstName);
                            self.pointOfContactLastName(accountProfile.pointOfContactLastName);
                            if (accountProfile.phoneNumber) {
                                const phoneNumber = _phoneNumberFormatter.removeNonNumericalAndLeadingOne(accountProfile.phoneNumber);
                                self.phoneNumber(phoneNumber);
                            }

                            const billingEmailAddresses = accountProfile.billingCommunications
                                .filter(({ type }) => type === EMAIL_ADDRESS_TYPE)
                                .map(_prepareBillingEmailAddressForDisplay);
                            self.billingCommunicationEmailAddresses(billingEmailAddresses);

                            let activatePromiseFactory = new PromiseFactoryConstructor();
                            activatePromiseFactory.defer((activateBillingCommunicationsPromise) => {
                                const billingSubscribers = accountProfile.billingCommunications.filter((c) => c.type === _commonState.types.user || c.type === _commonState.types.userGroup);
                                self.billingCommunicationSubscribers(billingSubscribers);
                                const commonStateSubscribers = billingSubscribers.map((subscriber) => {
                                    return subscriber.userId ? _commonState.get(subscriber.userId) : _commonState.get(subscriber.userGroupId);
                                });
                                self.subscriberSelectionViewModel.activate(commonStateSubscribers)
                                    .done(activateBillingCommunicationsPromise.resolve);
                            });

                            activatePromiseFactory.wait()
                                .done(getAccountProfilePromise.resolve);
                        });
                });

                _promiseFactory.defer((initializePromise) => {
                    initPromiseFactory.wait()
                        .done(() => {
                            self.modelStateObserver = new ModelStateObserverConstructor(self, true);
                            self.modelStateObserver.addChildObserver(self.subscriberSelectionViewModel.modelStateObserver);
                            self.modelStateObserver.commitData();

                            _validator.registerViewModel(self, _facade);

                            _disposables.push(self.country.subscribe(_onCountryChange));

                            initializePromise.resolve();
                        });
                });

                return _promiseFactory.wait();
            };
        };
    }
);

